import { render, staticRenderFns } from "./ModalFooterV2.vue?vue&type=template&id=4799e1a4&"
import script from "./ModalFooterV2.vue?vue&type=script&lang=js&"
export * from "./ModalFooterV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports